import React from 'react';
import Header, { LandingHeaderLinks } from '../../components/header/header';
import Footer from '../../components/footer/footer';
import './landing.scss';

function Landing() {
  return (
    <main className="c-corp">
      <Header>
        <LandingHeaderLinks />
      </Header>

      <section className="c-corp__hero">
        <div className="l-wrapper">
          <h1>Simple tools for everyday people.</h1>
          <p className="c-corp__sub">
            We design and build products that put professional results within
            anyone&apos;s reach — no design skills required.
          </p>
        </div>
      </section>

      <section className="c-corp__products" id="products">
        <div className="l-wrapper">
          <p className="c-corp__eyebrow">Products</p>
          <ul>
            <li className="c-corp__product">
              <div className="c-corp__product-head">
                <h2>Peckle</h2>
                <span>AI photo studio</span>
              </div>
              <p>
                An AI photo studio in your pocket. Turn a quick product photo
                into polished posts, price tags, and ads — ready for WhatsApp,
                Instagram, and marketplaces. No designer needed.
              </p>
              <a
                className="c-corp__product-link"
                href="https://peckle.ai"
                target="_blank"
                rel="noreferrer"
              >
                peckle.ai <span aria-hidden="true">→</span>
              </a>
            </li>
          </ul>
        </div>
      </section>

      <section className="c-corp__prose" id="company">
        <div className="l-wrapper">
          <p className="c-corp__eyebrow">Company</p>
          <h2>Gotok Technologies Limited</h2>
          <p>
            An independent software company. We build and operate our own
            consumer products end to end — design, engineering, support, and
            marketing — for small sellers in Nigeria, India, Brazil, and the
            United States.
          </p>
          <p>
            <a className="c-corp__product-link" href="/about">
              About Gotok <span aria-hidden="true">→</span>
            </a>
          </p>
        </div>
      </section>

      <section className="c-corp__contact">
        <div className="l-wrapper">
          <p className="c-corp__eyebrow">Contact</p>
          <a href="mailto:help@gotok.app">help@gotok.app</a>
        </div>
      </section>

      <Footer />
    </main>
  );
}

export default Landing;
